import { Routes } from '@angular/router';
import { RegisterComponent } from './components/register/register.component';
import { LoginComponent } from './components/login/login.component';
import { OnboardingFlowComponent } from './components/onboarding-flow/onboarding-flow.component';
import { AuthGuard } from './guards/auth.guard';
import { GuestGuard } from './guards/guest.guard';

export const routes: Routes = [
  {
    path: '',
    component: RegisterComponent,
    canActivate: [GuestGuard],
    data: { title: 'Register' }
  },
  {
    path: 'register',
    component: RegisterComponent,
    canActivate: [GuestGuard],
    data: { title: 'Register' }
  },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [GuestGuard],
    data: { title: 'Login' }
  },
  {
    path: 'onboard/:orgId',
    component: OnboardingFlowComponent,
    canActivate: [AuthGuard],
    data: { title: 'Onboarding' }
  },
  {
    path: '**',
    redirectTo: '/',
    pathMatch: 'full'
  }
];
